import React, { useState, useEffect } from 'react';
import { createSniper, updateSniper } from '../api';
import toast from 'react-hot-toast';

const SniperForm = ({ userId, existingConfig, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    userId,
    name: '',
    picture: '',
    click_interval: 1000,
    join_message: 'You have joined the queue.',
    queue_full_message: 'The queue is full. Try again later.',
    button_name: 'Join Queue',
    channel_id: '965410638530744381',
    server_id: '898743810207653919',
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (existingConfig) {
      setFormData({
        userId,
        name: existingConfig.name || '',
        picture: existingConfig.picture || '',
        click_interval: existingConfig.click_interval || 1000,
        join_message: existingConfig.join_message || 'You have joined the queue.',
        queue_full_message: existingConfig.queue_full_message || 'The queue is full. Try again later.',
        button_name: existingConfig.button_name || 'Join Queue',
        channel_id: existingConfig.channel_id || '965410638530744381',
        server_id: existingConfig.server_id || '898743810207653919',
      });
    } else {
      setFormData({
        userId,
        name: '',
        picture: '',
        click_interval: 1000,
        join_message: 'You have joined the queue.',
        queue_full_message: 'The queue is full. Try again later.',
        button_name: 'Join Queue',
        channel_id: '965410638530744381',
        server_id: '898743810207653919',
      });
    }
  }, [existingConfig, userId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === 'click_interval' ? parseInt(value) || 0 : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (existingConfig && existingConfig.id) {
        await updateSniper(existingConfig.id, formData);
        toast.success('Sniper updated');
      } else {
        await createSniper(formData);
        toast.success('Sniper created');
      }
      onSave();
    } catch (err) {
      toast.error('Failed to save configuration');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="form-header">
        <span>{existingConfig ? 'Edit Sniper' : 'Create Sniper'}</span>
        <button className="close-btn" onClick={onClose}>&times;</button>
      </div>
      <form onSubmit={handleSubmit} className="form-body">
        <div className="form-group">
          <label className="input-label">Name *</label>
          <input className="input-field" name="name" value={formData.name} onChange={handleChange} placeholder="My Queue Sniper" required />
        </div>
        <div className="form-group">
          <label className="input-label">Picture URL</label>
          <input className="input-field" name="picture" value={formData.picture} onChange={handleChange} placeholder="https://example.com/image.png" />
          {formData.picture && (
            <div style={{ marginTop: '8px' }}>
              <img
                src={formData.picture}
                alt=""
                style={{ width: '56px', height: '56px', borderRadius: '8px', objectFit: 'cover', border: '2px solid var(--bg-tertiary)' }}
                onError={(e) => { e.target.style.display = 'none'; }}
              />
            </div>
          )}
        </div>
        <div className="form-group">
          <label className="input-label">Click Interval (ms) *</label>
          <input className="input-field" type="number" name="click_interval" value={formData.click_interval} onChange={handleChange} min="1" max="60000" required />
        </div>
        <div className="form-group">
          <label className="input-label">Join Message *</label>
          <input className="input-field" name="join_message" value={formData.join_message} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label className="input-label">Queue Full Message</label>
          <input className="input-field" name="queue_full_message" value={formData.queue_full_message} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label className="input-label">Button Name *</label>
          <input className="input-field" name="button_name" value={formData.button_name} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label className="input-label">Discord Channel ID *</label>
          <input className="input-field" name="channel_id" value={formData.channel_id} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label className="input-label">Discord Server ID *</label>
          <input className="input-field" name="server_id" value={formData.server_id} onChange={handleChange} required />
        </div>
        <div style={{ marginTop: 'auto', paddingTop: '16px' }}>
          <button type="submit" className="btn btn-green" style={{ width: '100%', padding: '11px 16px' }} disabled={loading}>
            {loading ? 'Saving...' : 'Save Configuration'}
          </button>
        </div>
      </form>
    </>
  );
};

export default SniperForm;
